<template>
  <v-list-item
    :append-icon="icon"
    :disabled="disabled"
    data-testid="so-menu-item"
    @click="onClick"
  >
    <slot>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </slot>
  </v-list-item>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      title: {
        type: String,
        default: "",
      },
      icon: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      action: {
        type: Function,
        default: null,
      },
    },
    emits: ["click"],

    methods: {
      onClick() {
        this.action?.()
        this.$emit("click")
      },
    },
  })
</script>
